import React from "react";
import VotingHero from "./voting/VotingHero";

const VotingContent = ({ item: campaign }) => {
  if (!campaign) return null;

  return (
    <div className="max-w-2xl mx-auto">
      <VotingHero campaign={campaign} />
    </div>
  );
};

export default VotingContent;
